// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__x9JA-","name":"Logo_name__yonKO","description":"Logo_description__o1ZYe"};